import React from 'react';

const Recommendations = () => {
  const defaultData = {
    title: "Recommendations",
    recommendations: [
      {
        title: "Build the Innovation Flywheel:\n\"Variety → Trial → Satisfaction\"",
        bgColor: "bg-[#f3fadc]",
        borderColor: "border-lime-400",
        points: [
          "With 60% willing to explore variety and 54% trying new products, innovation momentum is strong across consumers.",
          "Bundle premium storytelling with trial incentives (sampling, loyalty Bonus as the emergent trial triggers), then reinforce with \"My 4 world\" messaging to create satisfaction and re-repeat."
        ]
      },
      {
        title: "Use Social Media as a Precision Growth Engine",
        bgColor: "bg-[#f3fadc]",
        borderColor: "border-lime-400",
        points: [
          "Only 23% responded ad to social media, bred but high-impact: YouTube (41%), Instagram (36%), Facebook influencers (38.7% YES).",
          "Focus spend on younger owners, urban households, multi-dog homes, and influencer-followers. These groups:",
          "Use precision targeting matched to premium segments and promotion before other routines (ingredient breakdowns, feeding transitions)."
        ]
      },
      {
        title: "Convert & Retain with Subscription:\nConvenience + Value",
        bgColor: "bg-[#f3fadc]",
        borderColor: "border-lime-500",
        points: [
          "Subscription interest is high (10–19% in fresh, 15% for Overall Dog Cost Savings (57%) ) and satisfaction is strong (76.3% Top2).",
          "Strengthen connection value: smaller reminder, flexible pausability, bundle upsell messaging.",
          "Add premium upsells as optional add-ons (treats, toppers, functional boosters), not the core hook."
        ]
      },
      {
        title: "Protect Against Cost Pressure with\nTiering + Pack Architecture",
        bgColor: "bg-[#f3fadc]",
        borderColor: "border-lime-500",
        points: [
          "More than half (57%) reported pricing changes, and increases are not slowing (see: Vet cost (68%)).",
          "Create a 3-tier portfolio (Good/Better/Best) with clear \"trade-up reasons\" (size, digestion, softer aging).",
          "Offer large-count packs with smaller \"starter sizes\" (smaller SKUs break into HHs, club bundles to defend against trade-down risk."
        ]
      }
    ],
    footerNote: "\"Growth will come from medium + functional innovation, converted into repeat via subscription convenience, and accelerated by social influencers among high-urban-digital segments—while protecting value-sensitive households through tiering and pack architecture.\""
  };

  const componentData =  defaultData;

  return (
     <div className="flex flex-col h-full items-center w-full">
      <h1 className="relative inline-block text-white text-center font-extrabold 
  max-w-4xl text-2xl lg:text-4xl font-nunito mb-4 
  bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
  px-6 py-2
  before:content-[''] before:absolute before:left-0 before:top-1/2 
  before:-translate-y-1/2 before:-translate-x-full
  before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
  before:border-r-[#92D050]

  after:content-[''] after:absolute after:right-0 after:top-1/2 
  after:-translate-y-1/2 after:translate-x-full
  after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
  after:border-l-[#8CC54F]">{componentData.title}</h1>
      

      {/* Recommendations Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-3">
        {componentData.recommendations.map((rec, index) => (
          <div
            key={index}
            className={`${rec.bgColor} border-2 ${rec.borderColor} p-3 rounded-xl `}
          >
            <h2 className="font-bold text-gray-900 mb-2 text-base whitespace-pre-line leading-tight">
              {rec.title}
            </h2>
            <ul className="space-y-1">
              {rec.points.map((point, idx) => (
                <li key={idx} className="text-sm text-gray-800 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1 flex-shrink-0">•</span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Footer Note */}
      <div className="bg-gray-100 border border-gray-300 rounded-lg p-3 mb-2">
        <p className="text-sm text-gray-800 text-center italic leading-relaxed">
          {componentData.footerNote}
        </p>
      </div>
    </div>
  );
};

export default Recommendations;